<div
  class="
    modal-header
    bg-primary
    text-white
    d-flex
    justify-content-between
    align-items-center
  "
>
  <h1>{{ title }}</h1>
  <button type="button" class="close" aria-label="Close" (click)="btnClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form class="col-12 mt-3" [formGroup]="securityForm">
    <div class="mb-3">
      <label class="form-label">Nombre</label>
      <input type="text" class="form-control" formControlName="name" />
      <div
        *ngIf="(name?.dirty || name?.touched) && name?.errors"
        class="text-danger"
      >
        <span *ngIf="name?.errors?.required">Nombre es requerido</span>
        <span *ngIf="name?.errors?.minlength"
          >Nombre debe tener al menos 3 caracteres</span
        >
      </div>
    </div>
    <!-- 
    <div class="mb-3" *ngIf="from == 'permisos'">
      <label class="form-label">Slug</label>
      <input type="text" class="form-control" formControlName="slug" />
      <div
        *ngIf="(slug?.dirty || slug?.touched) && slug?.errors"
        class="text-danger"
      >
        <span *ngIf="slug?.errors?.required">Slug es requerido</span>
        <span *ngIf="slug?.errors?.minlength"
          >Slug debe tener al menos 3 caracteres</span
        >
      </div>
    </div> -->

    <!-- <div class="mb-3">
      <label class="form-label">Descripcion del {{ nombre }}</label>

      <textarea
        class="form-control"
        rows="3"
        formControlName="description"
      ></textarea>
      <div
        *ngIf="
          (description?.dirty || description?.touched) && description?.errors
        "
        class="text-danger"
      >
        <span *ngIf="description?.errors?.required"
          >Descripcion es requerida</span
        >
      </div>
    </div> -->
  </form>
</div>
<div class="modal-footer">
  <button class="btn btn-light" (click)="btnCancel()">Cancelar</button>
  <button
    class="btn btn-primary"
    (click)="btnAccept()"
    [disabled]="securityForm.invalid"
  >
    Añadir {{ nombre }}
  </button>
</div>
